import React, { useRef, useState } from "react";
import { motion } from "framer-motion";
const { capabilities } = require("data/services.json");

export default function CapabilitiesList() {
  const videoRefs = useRef([]);
  const [hoverIndex, setHoverIndex] = useState(null);
  const [fadeOutIndex, setFadeOutIndex] = useState(null);
  const FADE_MS = 350;

  const handleEnter = (idx) => {
    setFadeOutIndex(null);
    setHoverIndex(idx);
    const v = videoRefs.current[idx];
    if (v) {
      try {
        v.pause();
        v.currentTime = 0;
        const p = v.play();
        if (p && typeof p.then === "function") p.catch(() => {});
      } catch {}
    }
  };

  const handleLeave = (idx) => {
    setHoverIndex(null);
    setFadeOutIndex(idx);
    const v = videoRefs.current[idx];
    if (v) {
      setTimeout(() => {
        try {
          v.pause();
          v.currentTime = 0;
          setFadeOutIndex(null);
        } catch {}
      }, FADE_MS);
    }
  };

  return (
    <div className="services-capabilities container">
      
      <motion.h2
        initial={{ opacity: 0, y: 10 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ delay: .2 }}
        className="k-title-sm lg:k-title-md"
      >
        Our Capabilities
      </motion.h2>

      <ul className="capabilities-list">
        {capabilities.map((card, i) => (
          <motion.li
            key={`${card.title}-${i}`}
            className="capability-card"
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "0px 0px -80px 0px" }}
            transition={{
              duration: 0.5,
              ease: "easeOut",
              delay: i * 0.15, 
            }}
            onMouseEnter={() => handleEnter(i)}
            onMouseLeave={() => handleLeave(i)}
          >
            <div className="capability-card-content">
              <h3 className="k-title-xs lg:k-title-sm">{card.title}</h3>
              <p className="k-text-sm xl:k-text-md description">{card.description}</p>
              <p className="k-text-sm xl:k-text-md">{card.paragraph}</p>
            </div>

            <div className="capability-card-img-wrapper">
              <img
                src={`/images/capabilities/${card.image}`}
                alt=""
                loading="lazy"
              />
              <motion.video
                ref={(el) => (videoRefs.current[i] = el)}
                src={`/videos/${card.video}`}
                muted
                loop
                playsInline
                preload="metadata"
                initial={{ opacity: 0 }}
                animate={{
                  opacity:
                    hoverIndex === i
                      ? 1
                      : fadeOutIndex === i
                      ? 0
                      : 0,
                }}
                transition={{ duration: FADE_MS / 1000, ease: "easeInOut" }}
              />
            </div>
          </motion.li>
        ))}
      </ul>
    </div>
  );
}
